import React, { useState } from 'react';

function Login({ onLogin }) {
    const [token, setToken] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (token.trim()) {
            setLoading(true);
            try {
                await onLogin(token.trim());
            } catch (err) {
                setError(true);
                setLoading(false);
            }
        } else {
            setError(true);
            setTimeout(() => setError(false), 2000);
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-primary"
            style={{
                background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 50%, #818cf8 100%)',
                padding: '20px'
            }}>
            <div className="card border-0 shadow-lg wow zoomIn"
                style={{
                    maxWidth: '450px',
                    width: '100%',
                    borderRadius: '24px',
                    background: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)'
                }}>
                <div className="card-body p-5 text-center">
                    <div className="mb-4">
                        <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: '80px', height: '80px' }}>
                            <i className="fas fa-shield-alt fa-2x text-primary"></i>
                        </div>
                        <h2 className="fw-bold text-dark mb-1">SpeedDate <span className="text-primary">PRO</span></h2>
                        <p className="text-muted small">Area Amministrativa Riservata</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-4 text-start">
                            <label className="form-label fw-bold small text-muted ms-1 mb-2">TOKEN DI ACCESSO</label>
                            <div className="input-group input-group-lg shadow-sm rounded-3 overflow-hidden border">
                                <span className="input-group-text bg-white border-0 py-3">
                                    <i className="fas fa-key text-muted"></i>
                                </span>
                                <input
                                    type="password"
                                    className={`form-control border-0 py-3 ${error ? 'is-invalid' : ''}`}
                                    placeholder="Inserisci il tuo token..."
                                    value={token}
                                    onChange={(e) => setToken(e.target.value)}
                                    autoFocus
                                />
                            </div>
                            {error && <div className="text-danger small mt-2 ms-1">Il token è obbligatorio</div>}
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-lg w-100 py-3 shadow-lg fw-bold rounded-pill"
                            disabled={loading}
                        >
                            {loading ? (
                                <><span className="spinner-border spinner-border-sm me-2"></span> Accesso in corso...</>
                            ) : 'ACCEDI AL PANNELLO'}
                        </button>
                    </form>

                    <div className="pt-3 border-top mt-2">
                        <p className="small text-muted mb-0">
                            <i className="fas fa-info-circle me-1"></i>
                            Se hai smarrito il token contatta l'assistenza tecnica.
                        </p>
                    </div>

                    {/* New Footer */}
                    <div className="text-center mt-5 pt-4 border-top ">
                        <p className="mb-0 text-muted small">SpeedDate PRO &copy; 2024 <a href="https://www.virtualbar.top" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-muted">https://www.virtualbar.top</a></p>
                    </div>
                </div>
            </div>

            <style jsx>{`
        .wow {
          animation-duration: 0.8s;
          animation-fill-mode: both;
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale3d(0.9, 0.9, 0.9); }
          50% { opacity: 1; }
        }
        .zoomIn { animation-name: zoomIn; }
      `}</style>
        </div>
    );
}

export default Login;
